import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/TermsOfService.css';

const TermsOfService = () => {
  const sections = [
    {
      number: "1",
      title: "INTRODUCTION",
      content: [
        'These Terms of Service ("Terms") govern your use of the DayDone platform, website, and related services ("Service"). By accessing or using DayDone, you agree to these Terms. If you do not agree, you must stop using the Service.',
        '',
        'DayDone',
        'Suite Ra01 195-197, Wood Street, London, United Kingdom, E17 3NU',
        'admin@daydone.co.uk',
        '',
        'You must be at least 18 to use DayDone.'
      ]
    },
    {
      number: "2",
      title: "THE SERVICE",
      content: [
        'DayDone provides job scheduling, customer management, work tracking, time logs, invoicing, team management, and related tools used by trade and service businesses.',
        '',
        'We may update or improve the Service at any time.'
      ]
    },
    {
      number: "3",
      title: "ACCOUNT REGISTRATION",
      content: [
        'You must provide accurate information when creating an account. You are responsible for safeguarding your password and for any activity on your account.',
        '',
        'If you create an account on behalf of a business, you confirm you have authority to bind that business to these Terms.'
      ]
    },
    {
      number: "4",
      title: "USER ROLES & ACCESS",
      content: [
        'Business owners may create team/employee accounts. You are responsible for:',
        '- Managing your users',
        '- Ensuring they follow these Terms',
        '- Revoking access when staff leave'
      ]
    },
    {
      number: "5",
      title: "CUSTOMER DATA & GDPR",
      content: [
        'You may store customer names, addresses, communications, job notes, and other data within DayDone. You are responsible for ensuring you have a lawful basis (e.g., legitimate interest) to store and process that customer data.',
        '',
        'DayDone acts as a Data Processor for customer data you upload. You must comply with UK GDPR.'
      ]
    },
    {
      number: "6",
      title: "PAYMENTS & BILLING",
      content: [
        'Paid plans renew automatically unless cancelled. Fees are billed monthly or annually in advance.',
        '',
        'Payment processing is handled by:',
        '- Stripe (card payments)',
        '- GoCardless (Direct Debit payments)',
        '',
        'We do not store payment card or bank details.',
        '',
        'Fees are non-refundable unless required by law.'
      ]
    },
    {
      number: "7",
      title: "FREE TRIALS",
      content: [
        'If you receive a free trial, DayDone may limit features during the trial. Your account will convert to a paid subscription unless cancelled before the trial ends.'
      ]
    },
    {
      number: "8",
      title: "THIRD-PARTY SERVICES & OUTAGES",
      content: [
        'DayDone relies on third-party partners, including hosting providers, email gateways, map/location services, Stripe, and GoCardless.',
        '',
        'These services may experience outages outside our control.',
        '',
        'DayDone is not responsible for downtime, delays, data loss, or performance issues caused by third-party systems.',
        '',
        'We will make reasonable efforts to resolve issues quickly.'
      ]
    },
    {
      number: "9",
      title: "ACCEPTABLE USE",
      content: [
        'You may not:',
        '- Upload harmful, illegal, or infringing content',
        '- Use DayDone to harass, abuse, or threaten others',
        '- Attempt to access or disrupt DayDone systems',
        '- Reverse-engineer or copy the platform',
        '- Upload malware or automated scripts',
        '- Use DayDone for unlawful activities',
        '- Access DayDone to build a competing product',
        '',
        'We may suspend accounts that violate these rules.'
      ]
    },
    {
      number: "10",
      title: "USER CONTENT",
      content: [
        'You retain ownership of all data you upload.',
        '',
        'You grant DayDone a licence to store, process, and display the content solely for the purpose of providing the Service.',
        '',
        'We do not sell user data.'
      ]
    },
    {
      number: "11",
      title: "DATA STORAGE & SECURITY",
      content: [
        'We use secure UK/EU-based hosting. Data is encrypted at rest and in transit.',
        '',
        'No system is 100% secure. You are responsible for maintaining strong passwords and internal access control.'
      ]
    },
    {
      number: "12",
      title: "SERVICE AVAILABILITY",
      content: [
        'We aim for high uptime but cannot guarantee the Service will be uninterrupted.',
        '',
        'Scheduled maintenance may occur.'
      ]
    },
    {
      number: "13",
      title: "TERMINATION",
      content: [
        'You may cancel your subscription at any time.',
        '',
        'We may suspend or terminate accounts for:',
        '- Non-payment',
        '- Abuse of the Service',
        '- Legal compliance reasons',
        '- Security risks',
        '- Breach of these Terms',
        '',
        'Upon termination, your access will cease. You may request a data export before closure.'
      ]
    },
    {
      number: "14",
      title: "LIMITATION OF LIABILITY",
      content: [
        'To the maximum extent permitted under UK law:',
        '- DayDone is not liable for lost profits, lost business, data loss, or indirect damages.',
        '- Our total liability is limited to the amount paid by you in the last 12 months.',
        '',
        'Nothing excludes liability for fraud or death/personal injury caused by negligence.'
      ]
    },
    {
      number: "15",
      title: "INDEMNITY",
      content: [
        'You agree to indemnify DayDone against claims arising from:',
        '- Your misuse of the Service',
        '- Your uploaded data',
        '- Your violation of laws or regulations'
      ]
    },
    {
      number: "16",
      title: "CONFIDENTIALITY",
      content: [
        'Both parties must keep confidential any non-public information disclosed during use of the Service.'
      ]
    },
    {
      number: "17",
      title: "GOVERNING LAW",
      content: [
        'These Terms are governed by the laws of England and Wales.',
        '',
        'Any disputes will be resolved exclusively in the courts of England and Wales.'
      ]
    },
    {
      number: "18",
      title: "CHANGES TO THESE TERMS",
      content: [
        'We may update these Terms. Material changes will be communicated via email or notification.',
        '',
        'Continuing to use the Service means you accept the updated Terms.'
      ]
    },
    {
      number: "19",
      title: "CONTACT",
      content: [
        'For questions or legal notices:',
        '',
        'admin@daydone.co.uk',
        '',
        'DayDone, Suite Ra01 195-197, Wood Street, London, E17 3NU'
      ]
    }
  ];

  return (
    <div className="terms-of-service">
      <div className="container">
        <div className="terms-header">
          <h1 className="terms-main-title">DAYDONE – TERMS OF SERVICE</h1>
          <p className="last-updated">Last updated: 12/08/2025</p>
        </div>

        <div className="terms-content">
          {sections.map((section) => (
            <section key={section.number} className="terms-section">
              <h2 className="section-title">
                {section.number}. {section.title}
              </h2>
              <div className="section-content">
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="section-paragraph">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="terms-footer">
          <p className="footer-text">
            © {new Date().getFullYear()} DayDone. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;